import {
	GET_SUBSCRIPTIONS,
	ADD_SUBSCRIPTION,
	UPDATE_SUBSCRIPTION,
	GET_SUBSCRIPTION_PACKAGES,
	CREATE_SUBSCRIPTION
} from '../../Actions/Admin/ManageSubscriptionActions';

const initialState = {
	subscriptions: [],
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_SUBSCRIPTIONS:
			return {
				...state,
				loading: true,
				subscriptions: action.payload
			};
		case ADD_SUBSCRIPTION:
			return {
				...state,
				subscriptions: action.payload
			};
		case CREATE_SUBSCRIPTION:
			return {
				...state,
				subscriptions: action.payload
			};
		case UPDATE_SUBSCRIPTION:
			return {
				...state,
				subscriptions: action.payload
            };
        case GET_SUBSCRIPTION_PACKAGES:
            return {
                ...state,
                subscriptionPackages: action.payload
            };
		default:
			return state;
	}
};
